<template>
  <div>
    <Header />
    <div class="content-web container mt-5">
      <!-- <Breadcrumb :data="breadcrumbs"></Breadcrumb> -->
      <div class="submission-title">
        <p>Lựa chọn lĩnh vực</p>
      </div>
      <div class="list-of-submission mb-5">
        <div class="row">
          <div
            v-for="item in typeSubmission"
            v-bind:key="item.id"
            class="grid-item col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
            @click="redirect(`${formUrl}/${item.code}`)"
          >
            <div class="item-wrap">
              <div class="item-thumb">
                <img alt="image" class="img-fit" v-bind:src="item.thumb" />
              </div>
              <div class="item-name">{{item.name}}</div>
              <p style="display:inline">{{item.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import freeStyleLogo from "@/assets/images/freedefine.png";
import proposalLogo from "@/assets/images/proposal.png";
import serviceOfferingLogo from "@/assets/images/servicesoffering.png";
import softwareComponentLogo from "@/assets/images/softwarecomponent.png";
import standardSolutionLogo from "@/assets/images/standardsolutions.png";
import technicalKnowledgeLogo from "@/assets/images/knowhow.png";
import * as CONFIG from "../../config/index.js";
import {ipType} from "../const/ipType";
export default {
  name: "NewSubmission",
  components: {
    Header,
    Footer,
    Breadcrumb
  },
  data() {
    return {
      formUrl: `${CONFIG.CLIENT_URL}/#/new-submission`,
      breadcrumbs: [
        { id: 1, name: "My Submission", href: "#" },
        { id: 2, name: "New Submission" }
      ],
      typeSubmission: ipType
    };
  },
  methods: {
    redirect: function(href) {
      window.location.href = href;
    }
  }
};
</script>

<style scoped>
.list-of-submission div[class*="col"] {
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 15px;
  cursor: pointer;
}

.list-of-submission .row {
  margin-right: -10px;
  margin-left: -10px;
}
.list-of-submission .item-thumb {
  height: 70px;
  width: 70px;
}
.list-of-submission .item-name {
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  color: #1e242f;
  padding: 10px 0;
  display: block;
}
.grid-item .item-wrap {
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
  padding: 25px 20px 15px;
  height: 320px;
  border: solid 1px #e3e9f0 !important;
}

.grid-item .item-wrap:hover {
  box-shadow: 2px 1px 4px 1px rgba(0, 0, 0, 0.16);
}

.list-of-submission p {
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: 0.06px;
  text-align: left;
  color: #898e97;
}
.submission-title {
  padding-top: 0;
  padding-bottom: 35px;
}
.submission-title p {
  font-size: 36px;
  font-weight: 600;
  font-style: normal;
  color: #1e242f;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/NewSubmission.vue